module.exports = __webpack_public_path__ + "img/s.7f59a5dc.png";